// extracted by mini-css-extract-plugin
export default {"block":"block_block__7ObeD","img":"block_img__V3d+z"};